import { render, staticRenderFns } from "./CourseTimeDialog.vue?vue&type=template&id=fb60af62&scoped=true"
import script from "./CourseTimeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseTimeDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CourseTimeDialog.vue?vue&type=style&index=0&id=fb60af62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb60af62",
  null
  
)

export default component.exports